import React from "react";
import PropTypes from 'prop-types';

const Modal = ({
    show,
    title,
    onClose,
    textButtonAction,
    onClickButtonAction,
    content
}) => {
    if (!show) return;
    return (
        <div className="modal-overlay">
            <div className="modal-content-compact">
                <div className="modal-header">
                    <h3>{title}</h3>
                    <button className="modal-close-btn" onClick={onClose}>
                        ×
                    </button>
                </div>

                <div className="modal-form-compact">
                    <div>
                        {content}
                    </div>
                    <div className="modal-buttons-compact">
                        {
                            typeof onClickButtonAction !== "undefined" && (
                                <button type="button" onClick={onClickButtonAction} className="btn btn-primary-compact">
                                    {textButtonAction}
                                </button>
                            )
                        }
                        <button
                            type="button"
                            className="btn btn-secondary-compact"
                            onClick={onClose}
                        >
                            Cancelar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

Modal.propTypes = {
    show: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    content: PropTypes.node,
    textButtonAction: PropTypes.string,
    onClickButtonAction: PropTypes.func
};


export default Modal;
